export const DASHBOARDS_2_URL = 'dashboards'
export const DASHBOARD_URL = DASHBOARDS_2_URL
export const DASHBOARDS_2_DETAIL_URL = 'dashboards-detail'
export const DASHBOARDS_2_EDIT_URL = 'dashboards-edit'
export const DASHBOARDS_2_TRANSACTION_PATH = `/project/:id/${DASHBOARDS_2_URL}`
export const DASHBOARDS_2_DETAIL_TRANSACTION_PATH = `/project/:id/${DASHBOARDS_2_URL}/:customDashboardId`
export const DASHBOARDS_2_EDIT_TRANSACTION_PATH = `/project/:id/${DASHBOARDS_2_URL}/:customDashboardId/edit`

export const dashboards2DetailPath = (
  projectId: string,
  dashboardId: string,
): string => `/project/${projectId}/${DASHBOARDS_2_URL}/${dashboardId}`

export const dashboards2EditPath = (
  projectId: string,
  dashboardId: string,
): string => `/project/${projectId}/${DASHBOARDS_2_URL}/${dashboardId}/edit`

export const dashboards2ListPath = (projectId: string): string =>
  `/project/${projectId}/${DASHBOARDS_2_URL}`

export const DASHBOARDS_2_TEMPLATE_SETUP_TRANSACTION_PATH = `/project/:id/${DASHBOARDS_2_URL}/templates/:templateId/setup`

export const dashboardTemplateSetupPath = (
  projectId: string,
  templateId: string,
): string =>
  `/project/${projectId}/${DASHBOARDS_2_URL}/templates/${templateId}/setup`

export const SHARE_DASHBOARD_V2 = `/project/:id/${DASHBOARDS_2_URL}/:dashboardId/shared/:token`

// Old emailed share links minted before the v1->v2 migration. The v1 slug
// (features/dashboard/paths.ts) redirected here in two hops; serving it
// directly off the v2 shared viewer collapses that to one.
export const LEGACY_SHARE_CUSTOM_DASHBOARD =
  '/project/:id/shared-dashboard/:token'
